console.log("REQUIRED SELECT JS LOADED");

document.addEventListener("click", function(e) {

  const btn = e.target.closest('[type="submit"][name="add"]');
  if (!btn) return;

  const form = btn.closest("form");
  if (!form) return;

  const selects = form.querySelectorAll(".required-select");

  for (const select of selects) {
    const label = select.dataset.label || "項目";

    if (!select.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert(label + " を選択してください");
      return false;
    }
  }

}, true); // ← captureフェーズで止める


document.addEventListener("submit", function(e) {

  const form = e.target;
  if (!form || !form.action.includes("/cart/add")) return;

  const selects = form.querySelectorAll(".required-select");

  for (const select of selects) {
    const label = select.dataset.label || "項目";

    if (!select.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert(label + " を選択してください");
      return false;
    }

    let hidden = form.querySelector(
      `input[name="properties[${label}]"]`
    );

    if (!hidden) {
      hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = `properties[${label}]`;
      form.appendChild(hidden);
    }

    hidden.value = select.value;
  }

}, true);
